<template>
  <div>
    <!--<editor-fold desc="Finished filter">-->
    <v-row no-gutters>
      <v-col cols="8">
        <v-btn
          block
          :color="!filtersDirty.finished ? 'primary' : 'grey'"
          :text="filtersDirty.finished"
          class="ma-0 text-none"
          @click="filtersDirty.finished = false"
        >
          Unfinished
        </v-btn>
      </v-col>
      <v-col cols="8">
        <v-btn
          block
          :color="filtersDirty.finished ? 'primary' : 'grey'"
          :text="!filtersDirty.finished"
          class="ma-0 text-none"
          @click="filtersDirty.finished = true"
        >
          Finished
        </v-btn>
      </v-col>
    </v-row>
    <!--</editor-fold>-->
    <v-list
      dense
      class="transparent"
    >
      <v-list-item
        v-for="priority in priorityData"
        :key="priority.key"
        class="list--bordered"
        :class="{ 'primary': filtersDirty.priority === priority.key }"
        @click="filtersDirty.priority === priority.key ? filtersDirty.priority = null : filtersDirty.priority = priority.key"
      >
        <v-list-item-content>
          <v-list-item-title :class="{ 'white--text': filtersDirty.priority === priority.key }">
            {{ priority.label }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon>
          <v-avatar
            size="10px"
            class="mt-2"
            :color="priority.color"
          />
        </v-list-item-icon>
      </v-list-item>
    </v-list>
    <!--<editor-fold desc="Categories filter">-->
    <v-list
      dense
      class="transparent"
    >
      <v-list-item
        v-for="category in categoryData"
        :key="category.key"
        class="list--bordered"
        :class="{ 'primary': filtersDirty.categories.indexOf(category.key) > -1 }"
        @click="$emit('toggle:category', category.key)"
      >
        <v-list-item-content>
          <v-list-item-title :class="{ 'white--text': filtersDirty.categories.indexOf(category.key) > -1 }">
            {{ category.label }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Title filter">-->
    <v-text-field
      v-model="filtersDirty.title"
      label="Title"
      solo
      hide-details
      clearable
      dense
      class="mb-2"
    />
    <!--</editor-fold>-->
    <v-select
      v-if="$can('service-allow-all-countries')"
      v-model="filtersDirty.organisation_id"
      label="Company"
      solo
      hide-details
      dense
      :items="[ { value: 1, text: 'Yacht Manager' } ]"
      class="mb-2"
    />
    <!--<editor-fold desc="Yacht filter">-->
    <yacht-modal-select
      v-model="filtersDirty.yacht_ids"
      label="Yachts"
      solo
      hide-details
      clearable
      multiple
      chips
      dense
      class="mb-2"
      :dialog-visible.sync="yachtModalSelectVisible"
      @submit="yachtModalSelectVisible = false"
    />
    <!--</editor-fold>-->
    <!--<editor-fold desc="Owner request filter">-->
    <v-select
      v-if="$can('decide-service-requests', 'ServiceTask')"
      v-model="filtersDirty.request_status"
      label="Owner Request"
      solo
      hide-details
      clearable
      dense
      :items="requestStatusArray"
      item-value="key"
      item-text="label"
      class="mb-2"
    />
    <!--</editor-fold>-->
    <!--<editor-fold desc="Assignee filter">-->
    <assignee-modal-select
      v-show="filtersDirty.finished"
      v-model="filtersDirty.assigned_to"
      label="Finished by"
      solo
      hide-details
      clearable
      multiple
      chips
      dense
      class="mb-2"
      :dialog-visible.sync="assigneeModalSelectVisible"
      @submit="assigneeModalSelectVisible = false"
    />
    <!--</editor-fold>-->
    <!--<editor-fold desc="Date filters">-->
    <v-row
      v-show="filtersDirty.finished"
      class="flex-nowrap mb-1"
    >
      <v-col
        cols="8"
      >
        <v-menu
          v-model="filtersDateFinishedAtFromMenu"
          :close-on-content-click="false"
          max-width="290"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="filtersDirty.finished_at_from ? $moment(filtersDirty.finished_at_from).format('DD.MM.YYYY') : ''"
              solo
              label="From"
              clearable
              hide-details
              dense
              readonly
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="filtersDirty.finished_at_from"
            @change="filtersDateFinishedAtFromMenu = false"
          />
        </v-menu>
      </v-col>
      <v-col cols="8">
        <v-menu
          v-model="filtersDateFinishedAtToMenu"
          :close-on-content-click="false"
          max-width="290"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="filtersDirty.finished_at_to ? $moment(filters.finished_at_to).format('DD.MM.YYYY') : ''"
              solo
              label="To"
              clearable
              hide-details
              dense
              readonly
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="filtersDirty.finished_at_to"
            @change="filtersDateFinishedAtToMenu = false"
          />
        </v-menu>
      </v-col>
    </v-row>
    <!--</editor-fold>-->
    <!--<editor-fold desc="Insurance / Warranty Claims">-->
    <v-select
      v-model="filtersDirty.warranty_claim_status"
      label="Warranty Claim"
      solo
      hide-details
      clearable
      dense
      :items="[ { key: 'pending', label: 'Pending' }, { key: 'accepted', label: 'Accepted' }, { key: 'declined', label: 'Declined' }]"
      item-value="key"
      item-text="label"
      class="mb-2"
    />

    <v-select
      v-model="filtersDirty.insurance_claim"
      label="Insurance Claim"
      solo
      hide-details
      clearable
      dense
      :items="[ { key: 'deposit_insurance', label: 'Damage by charter client' }, { key: 'hull_insurance', label: 'Hull insurance' }]"
      item-value="key"
      item-text="label"
      class="mb-2"
    />

    <v-text-field
      v-model="filtersDirty.id"
      label="Service Task ID"
      solo
      hide-details
      clearable
      dense
    />
    <!--</editor-fold>-->
  </div>
</template>
<script>
import AssigneeModalSelect from '@/components/service/helpers/AssigneeModalSelect'
import YachtModalSelect from '@/components/service/helpers/YachtModalSelect'
import ServiceTask from '@/models/ServiceTask'

export default {
    name: 'ServiceTaskFilters',
    components: { AssigneeModalSelect, YachtModalSelect },
    props: {
      filters: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        filtersDateFinishedAtFromMenu: false,
        filtersDateFinishedAtToMenu: false,
        yachtModalSelectVisible: false,
        assigneeModalSelectVisible: false
      }
    },
    computed: {
      filtersDirty: {
        get: function () {
          return this.filters
        },
        set: function (value) {
          this.$emit('update:filters', value)
        }
      },
      requestStatusArray() {
        return Object.entries(this.requestStatusData).map(([key, value]) => value)
      }
    },
    created() {
      this.categoryData = ServiceTask.categoryData
      this.requestStatusData = ServiceTask.requestStatusData
      this.priorityData = ServiceTask.priorityData
    }
  }
</script>
<style>

  .v-badge__badge span {
    font-size: 12px;
  }

</style>
